import { createNewSortInstance } from 'fast-sort';

/**
 * Sorts an array of objects by a property that contains a natural sort order.
 * @example
 * const sorted = naturalSort([{ name: 'a-1b' }, { name: 'a-1a' }, { name: 'a-2' }]).asc((el) => el.name));
 * console.log(sorted); // [{ name: 'a-1a' }, { name: 'a-1b' }, { name: 'a-2' }]
 */
export const naturalSort = createNewSortInstance({
  comparer: new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' }).compare
});
